module.exports = require("serialize-javascript");


//////////////////
// WEBPACK FOOTER
// external "serialize-javascript"
// module id = 16
// module chunks = 0